const masks = {
    phone: {
        pattern: "(999) 999-9999",
        regex: "^\\([0-9]{3}\\) [0-9]{3}-[0-9]{4}$",
    },
    dateOfBirth: {
        pattern: "99/99/9999",
        regex: "^(0[1-9]|1[0-2])\\/(0[1-9]|1[0-9]|2[0-9]|3[01])\\/(19|20)[0-9]{2}$",
    },
    ssn: {
        pattern: "999-99-9999",
        regex: "^[0-9]{3}-[0-9]{2}-[0-9]{4}$",
    },
    cardExpirationDate: {
        pattern: "99/99",
        regex: "^(0[1-9]|1[0-2])\\/[0-9]{2}$",
    },
};

export default masks;
